"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answerDeletePermission = exports.answerEditPermission = exports.answerReadPermission = exports.switchOnAnswerStatus = void 0;
const AnswerUserRelationState_1 = require("../schema/AnswerUserRelationState");
const plex_1 = require("./plex");
function switchOnAnswerStatus(currentUserRelation, { ownDraft, draft, ownNonApproved, nonApproved, approved }) {
    switch (currentUserRelation) {
        case AnswerUserRelationState_1.AnswerUserRelationState.OwnDraft:
            return ownDraft();
        case AnswerUserRelationState_1.AnswerUserRelationState.Draft:
            return draft();
        case AnswerUserRelationState_1.AnswerUserRelationState.OwnNonApproved:
            return ownNonApproved();
        case AnswerUserRelationState_1.AnswerUserRelationState.NonApproved:
            return nonApproved();
        case AnswerUserRelationState_1.AnswerUserRelationState.Approved:
            return approved();
    }
}
exports.switchOnAnswerStatus = switchOnAnswerStatus;
function answerReadPermission(currentUserRelation) {
    return switchOnAnswerStatus(currentUserRelation, {
        ownDraft: () => plex_1.Permission.READ_OWN_DRAFT_ANSWER,
        draft: () => null,
        ownNonApproved: () => plex_1.Permission.READ_NON_DRAFT_ANSWER,
        nonApproved: () => plex_1.Permission.READ_NON_DRAFT_ANSWER,
        approved: () => plex_1.Permission.READ_NON_DRAFT_ANSWER,
    });
}
exports.answerReadPermission = answerReadPermission;
function answerEditPermission(currentUserRelation) {
    return switchOnAnswerStatus(currentUserRelation, {
        ownDraft: () => plex_1.Permission.EDIT_OWN_DRAFT_ANSWER,
        draft: () => null,
        ownNonApproved: () => plex_1.Permission.EDIT_OWN_NON_APPROVED_ANSWER,
        nonApproved: () => plex_1.Permission.EDIT_NON_APPROVED_ANSWER,
        approved: () => plex_1.Permission.EDIT_APPROVED_ANSWER,
    });
}
exports.answerEditPermission = answerEditPermission;
function answerDeletePermission(currentUserRelation) {
    return switchOnAnswerStatus(currentUserRelation, {
        ownDraft: () => plex_1.Permission.DELETE_OWN_DRAFT_ANSWER,
        draft: () => null,
        ownNonApproved: () => plex_1.Permission.DELETE_OWN_NON_APPROVED_ANSWER,
        nonApproved: () => plex_1.Permission.DELETE_NON_APPROVED_ANSWER,
        approved: () => plex_1.Permission.DELETE_APPROVED_ANSWER,
    });
}
exports.answerDeletePermission = answerDeletePermission;
//# sourceMappingURL=answer.js.map